"use client";

import { SiteNoticeBanner } from "@/components/site-notice-banner";
import { useStripeConfig } from "@/lib/useStripeConfig";
import { cn } from "@/lib/utils";

type StripeSandboxBannerProps = {
  className?: string;
};

export const StripeSandboxBanner = ({ className }: StripeSandboxBannerProps) => {
  const { isTestMode, error } = useStripeConfig();

  if (error || !isTestMode) {
    return null;
  }

  return (
    <SiteNoticeBanner
      tone="sandbox"
      title="Sandbox billing mode"
      detail="Charges are not live."
      className={cn(className)}
    />
  );
};
